export default __webpack_public_path__ + "static/media/teamProfile-sq.a48e018d.jpg";